import React, { useState, useEffect } from 'react'
import { DialogTitle, Grid, Button, DialogContent, DialogActions, Dialog } from '@mui/material';
import Controls from "./controls/Controls";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';


export default function OtherDocumentsDialog({ open, handleClose, formData, setFormData, handleFormSubmit, documentType, enabled }) {
  const [formElements, setFormElements] = useState([]);
  const [overdueDocuments, setOverdueDocuments] = useState([]);
  
  const handleRemoveLastElement = () => {
    setFormElements((prevElements) => {
      const updatedElements = prevElements.slice(0, -1);
      setFormData({ ...formData, otherDocuments: updatedElements });
      return updatedElements;
    });
  };

  const handleAddElement = () => {
    setFormElements((prevElements) => [...prevElements, { documentTypeId: null, quantity: '' }]);
  };

  useEffect(() => {

    const filteredDocuments = formData?.otherDocuments?.filter(item => item.documentTypeId !== 171) || [];

    if (filteredDocuments?.length > 0) {
      setFormElements(filteredDocuments); 
    } else {
      setFormElements([]); 
    }
  }, [formData]);

  useEffect(() => {
    if (open) {
      // Ustawiamy prevDocuments w momencie otwarcia popupu
      setOverdueDocuments(formData?.otherDocuments?.filter(item => item.documentTypeId === 171) || []);
    }
  }, [open]); 

  const isNumber = (value) => {
    const reg = /^[0-9]+$/;
    return reg.test(value);
  };

  const handleElementChange = (event, index) => {
    const { name, value } = event.target;
    if (name === "quantity" && !isNumber(value) && value !== "") {
      return; // Don't update the state if value is not a number and it's not empty
    }
    setFormElements((prevElements) => {
      const updatedElements = [...prevElements];
      updatedElements[index] = {
        ...updatedElements[index],
        [name]: value
      };
      setFormData({ ...formData, otherDocuments: updatedElements });
      return updatedElements;
    });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        {enabled ? (
          <DialogTitle id="alert-dialog-title">Dodaj dokument</DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">Podgląd</DialogTitle>
        )}

        <Divider />
        <DialogContent>
          <form>
            {formElements && formElements.length > 0 ? (
              formElements.map((element, index) => (
                <Grid
                  key={index}
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 4 }}
                >
                  <Grid item xs={9}>
                    <Controls.Select
                      name="documentTypeId"
                      label="Nazwa dokumentu"
                      value={element.documentTypeId || null}
                      onChange={(e) => handleElementChange(e, index)}
                      options={documentType}
                      disabled={!enabled}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Controls.Input
                      name="quantity"
                      value={String(element.quantity) || ''}
                      onChange={(e) => handleElementChange(e, index)}
                      placeholder="Podaj liczbę"
                      label="Liczba"
                      disabled={!enabled}
                    />
                  </Grid>
                </Grid>
              ))
            ) : (
              <p style={{ fontSize: 18 }}>Brak elementów...</p>
            )}
            <Box sx={{ m: '15px' }} />
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={6}>
                {formElements?.length > 0 && enabled && ( // <-- Add enabled check here
                  <Button variant="contained" onClick={handleRemoveLastElement}>
                    Usuń ostatni
                  </Button>
                )}
              </Grid>
              <Grid item xs={6}>
                {enabled && ( // <-- Add enabled check here
                  <Button style={{ float: 'right' }} variant="contained" color="secondary" onClick={handleAddElement}>
                    Dodaj dokument
                  </Button>
                )}
              </Grid>
            </Grid>
            <Box sx={{ m: '30px' }} />
          </form>
        </DialogContent>
        <DialogActions>
          {enabled ? (
            <>
              <Button onClick={handleClose} color="secondary" variant="outlined">
                Anuluj
              </Button>
              <Button color="primary" onClick={() => handleFormSubmit(overdueDocuments)} variant="contained">
                Zapisz
              </Button>
            </>
          ) : (
            <Button onClick={handleClose} color="primary" variant="contained">
              Zamnij
            </Button>

          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}